import Icon from "./Icon";

// Renders the standard footer for a paginated list.
// `meta` is the shape returned by Laravel's paginate() — {current_page, last_page, from, to, total, per_page}.
export default function Pagination({ meta, page, onPageChange, disabled, perPage, onPerPageChange }) {
  if (!meta) return null;
  const current = meta.current_page ?? page ?? 1;
  const last = meta.last_page ?? 1;
  const total = meta.total ?? 0;
  const from = meta.from ?? 0;
  const to = meta.to ?? 0;

  const go = (p) => {
    if (disabled || p < 1 || p > last || p === current) return;
    onPageChange?.(p);
  };

  return (
    <div
      style={{
        display: "flex",
        alignItems: "center",
        justifyContent: "space-between",
        gap: 12,
        // The full footer runs ~480px wide; without wrapping it forces
        // sideways scroll on phones — let the controls drop to a second line.
        flexWrap: "wrap",
        padding: "10px 18px",
        borderTop: "1px solid var(--border)",
        background: "var(--surface-2)",
      }}
    >
      <div className="t-muted text-sm">
        {total === 0 ? "No results" : `Showing ${from}-${to} of ${total}`}
      </div>
      <div className="row gap-sm" style={{ flexWrap: "wrap" }}>
        {onPerPageChange && perPage != null && (
          <select
            className="select"
            style={{ width: 100 }}
            value={perPage}
            disabled={disabled}
            onChange={(e) => onPerPageChange(Number(e.target.value))}
          >
            {[10, 25, 50, 100].map((n) => (
              <option key={n} value={n}>{n}/page</option>
            ))}
          </select>
        )}
        <button
          className="btn btn-secondary btn-sm"
          disabled={disabled || current <= 1}
          onClick={() => go(1)}
          title="First page"
        >
          «
        </button>
        <button
          className="btn btn-secondary btn-sm"
          disabled={disabled || current <= 1}
          onClick={() => go(current - 1)}
        >
          <Icon name="chevron-left" size={13} />
        </button>
        <span className="text-sm" style={{ padding: "0 4px" }}>
          Page <b>{current}</b> of {last}
        </span>
        <button
          className="btn btn-secondary btn-sm"
          disabled={disabled || current >= last}
          onClick={() => go(current + 1)}
        >
          <Icon name="chevron-right" size={13} />
        </button>
        <button
          className="btn btn-secondary btn-sm"
          disabled={disabled || current >= last}
          onClick={() => go(last)}
          title="Last page"
        >
          »
        </button>
      </div>
    </div>
  );
}
